export default __webpack_public_path__ + "static/affiliate-program-AffiliateApp-ec1282ba7582cae9c2264cd57f87fcc7.webp";